import React from 'react';
import config from '../../config';

const TsAndCs = () => {
  return (
    <React.Fragment>
      <div className="wf-account__text">
        <span>By signing in or creating an account you accept our <b>Privacy and Cookies Policy</b>, and Terms and Conditions.</span>
      </div>
      <div className="wf-account__text">
        <a href={`${config.WordPressURL}privacy-policy/`} target="_blank" rel="noreferrer">
          {`Privacy & Cookies policy`}
        </a>
      </div>
      <div className="wf-account__text">
        <a href={`${config.WordPressURL}terms-conditions`} target="_blank" rel="noreferrer">
          {`Terms & Conditions`}
        </a>
      </div>
      {/* <div className="wf-account__text">
        {`© regulationcity.com`}
      </div> */}
    </React.Fragment>
  );
};

export default TsAndCs;
